var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import VueDialog from "../../../interface/IVueDialog";
import SupplierOrganService from '../../../api/SupplierOrganService';
import { cloneDeep } from 'lodash';
import AccoutCheckService from '@/api/AccoutCheckService';
var AddDialog = (function (_super) {
    __extends(AddDialog, _super);
    function AddDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.action = 'add';
        _this.formData = {
            is_tax_type: '1',
            organ_id: '',
            organ_name: '',
            organ_code: '',
            is_default: 0,
            bank: '',
            banknumber: '',
            company_name: '',
            credit_code: '',
            company_address: '',
            area_code: '',
            company_phone: '',
            tax_province_id: '',
            tax_qualify: 1,
            export_qualify: 1,
        };
        _this.provinceList = [];
        _this.rules = {};
        return _this;
    }
    AddDialog.prototype.created = function () {
        this.service = SupplierOrganService.getInstance();
        this.accoutcheckService = AccoutCheckService.getInstance();
        this.initProvince();
        if (this.row && this.row.organ_id) {
            var formData = cloneDeep(this.row);
            if (formData.company_phone && formData.company_phone.includes('-')) {
                var phoneArr = formData.company_phone.split('-');
                formData.area_code = phoneArr[0];
                formData.company_phone = phoneArr[1];
            }
            this.formData = formData;
        }
    };
    AddDialog.prototype.mounted = function () {
    };
    AddDialog.prototype.initProvince = function () {
        var _this = this;
        this.accoutcheckService.getProvince()
            .then(function (res) {
            var _a = res.data, success = _a.success, data = _a.data;
            if (success) {
                _this.provinceList = data;
            }
            console.log('res>>>', res);
        });
    };
    AddDialog.prototype.querySearch = function (queryString, cb) {
        var _this = this;
        if (!/^\s*$/.test(queryString) && queryString.length >= 3) {
            this.accoutcheckService.getCompanyByKeyword({
                keyword: queryString
            }).then(function (res) {
                console.log('querySearch res>>>', res);
                if (res.data.code === 0) {
                    var results = res.data.data.map(function (item) {
                        return {
                            value: item.company_name,
                            code: item.company_license_code
                        };
                    });
                    cb(results);
                }
            }).catch(function (err) {
                _this.$message.error(err.msg || err.message);
            });
        }
        else {
            cb([]);
        }
    };
    AddDialog.prototype.handleSelect = function (item) {
        var _this = this;
        this.formData.company_name = item.value;
        this.formData.credit_code = item.code;
        this.accoutcheckService.getCompanyInfo({ company_name: item.value, license_code: item.code })
            .then(function (res) {
            console.log('res>>>', res);
            if (res.data.data.length == 0) {
                _this.formData.company_address = '';
                _this.formData.area_code = '';
                _this.formData.company_phone = '';
                _this.formData.tax_province_id = '';
                _this.formData.province_name = '';
            }
            else {
                var data = res.data.data;
                console.log(data);
                _this.formData.company_address = data.location;
                var phones = data.fixedPhone.split("-");
                if (phones.length == 1) {
                    _this.formData.area_code = '';
                    _this.formData.company_phone = data.fixedPhone;
                }
                else {
                    _this.formData.area_code = phones[0];
                    _this.formData.company_phone = phones[1];
                }
                _this.formData.tax_province_id = data.province_id;
                _this.formData.province_name = data.province;
            }
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    AddDialog.prototype.close = function () {
        this.$closeDialog();
    };
    AddDialog.prototype.save = function () {
        var _this = this;
        this.$validator.validateScopes().then(function (res) {
            if (!res) {
                _this.$message.error("请填写所有必填字段");
                return;
            }
            var postData = cloneDeep(_this.formData);
            postData.company_phone = postData.area_code ? postData.area_code + "-" + postData.company_phone : postData.company_phone;
            postData.province_name = _this.provinceName;
            if (postData.organ_id) {
                _this.editSave(postData);
            }
            else {
                _this.addSave(postData);
            }
        });
    };
    AddDialog.prototype.addSave = function (params) {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.addSave(params).then(function (res) {
            if (res.data.success) {
                _this.$message.success('添加成功！');
                _this.$emit('add_supplierorgan:ok');
                _this.$closeDialog();
            }
            else {
                _this.$message.error(res.data.msg);
            }
            ;
            loadingInstance.close();
        }).catch(function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        });
    };
    AddDialog.prototype.editSave = function (params) {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.editSave(params).then(function (res) {
            loadingInstance.close();
            if (res.data.success) {
                _this.$message.success('编辑成功！');
                _this.$emit('edit_supplierorgan:ok');
                _this.$closeDialog();
            }
            else {
                _this.$message.error(res.data.msg);
            }
            ;
        }).catch(function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        });
    };
    AddDialog = __decorate([
        Component({
            computed: {
                provinceName: function () {
                    var id = this.formData.tax_province_id;
                    var province = this.provinceList.find(function (item) { return item.id === id; });
                    return province ? province.name : '';
                }
            }
        })
    ], AddDialog);
    return AddDialog;
}(VueDialog));
export default AddDialog;
